import { Badge, Center, Text } from '@chakra-ui/react'
import type { components } from 'src/lib/api-client/schema.gen'
import { colors } from 'src/lib/chakra-theme/foundations/colors'

type Props = {
  status: components['schemas']['output.IcfRevStatus']
}

const fontColor = (
  status: components['schemas']['output.IcfRevStatus'],
): string | undefined => {
  switch (status) {
    case 'Saved':
      return colors.yellow[600]
    case 'Published':
      return colors.green[600]
    case 'Disabled':
      return colors.gray[400]
    default:
      return undefined
  }
}

const backgroundColor = (
  status: components['schemas']['output.IcfRevStatus'],
): string | undefined => {
  switch (status) {
    case 'Saved':
      return colors.yellow[100]
    case 'Published':
      return colors.green[100]
    default:
      return undefined
  }
}

const text = (
  status: components['schemas']['output.IcfRevStatus'],
): string | null => {
  switch (status) {
    case 'Saved':
      return '一時保存'
    case 'Published':
      return '公開'
    case 'Disabled':
      return '無効'
    default:
      return null
  }
}

export const IcfDocumentRevisionStatusBadge: React.FC<Props> = ({ status }) => {
  return (
    <Badge
      sx={{
        width: '72px',
        height: '25px',
        display: 'flex',
        justifyContent: 'center',
        color: fontColor(status),
        backgroundColor: backgroundColor(status),
      }}
    >
      <Center>
        <Text as="span" fontWeight="bold" fontSize="10px">
          {text(status)}
        </Text>
      </Center>
    </Badge>
  )
}
